<template>
    <div class="experience-card" :style="{ opacity: opacity }">
        <img :src="getImageSrc" :alt="header">
        <div class="text-container">
            <div class="header">{{ header }}</div>
            <div class="description">{{ description }}</div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ExperienceCard",
  props: {
    header: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    opacity: {
      type: Number,
      default: 0.1,
    },
  },
  computed: {
    getImageSrc() {
      // Проверяем, что imageSrc существует
      if (!this.imageSrc) {
        return '';
      }
      // Если путь начинается с @/, используем require для правильной обработки
      if (this.imageSrc.startsWith('@/')) {
        const path = this.imageSrc.replace('@/', '');
        try {
          return require(`@/${path}`);
        } catch (e) {
          return this.imageSrc;
        }
      }
      return this.imageSrc;
    }
  }
};
</script>

<style scoped>
.experience-card {
    display: flex;
    justify-content: start;
    align-items: center;
    padding-top: clamp(16px, 1.67vw, 32px);
    padding-bottom: clamp(16px, 1.67vw, 32px);
    transition: opacity 0.3s ease;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.experience-card:first-child {
    border-top: none;
}

.text-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header {
    font-size: clamp(12px, 1.67vw, 32px);
    width: 40%;
}

.description {
    font-size: clamp(8px, 0.83vw, 16px);
    width: 60%;
    opacity: 0.5;
}

@media screen and (max-width: 768px) {
  .text-container {
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      gap: 12px;
  }

  .description {
    width: 100%;
  }

  .header {
    width: 100%;
  }

  .experience-card {
    display: flex;
    justify-content: center;
  }
}
</style>
